import { type PresetView, useActivePreset } from "~/components/planning/presetView"
import { INVENTORY_CALENDAR_PRODUCT_TABLE_ID, INVENTORY_PAGE_TABLE_ID } from "~/constants"
import InventoryCalendar from "~/pages/sales-operations/inventory-calendar"
import Inventory from "~/pages/sales-operations/inventory-overview"

type InventoryPresetMeta = { kind: "overview" | "calendar" }

export const INVENTORY_ANALYSIS_PRESET_GROUP_ID = "inventory-analysis"

const INVENTORY_ANALYSIS_PRESETS: PresetView<InventoryPresetMeta>[] = [
  {
    id: "overview",
    name: "Overview",
    tableId: INVENTORY_PAGE_TABLE_ID,
    meta: { kind: "overview" },
  },
  {
    id: "calendar",
    name: "Calendar",
    tableId: INVENTORY_CALENDAR_PRODUCT_TABLE_ID,
    meta: { kind: "calendar" },
  },
]

export default function InventoryAnalysis() {
  const { activePreset } = useActivePreset(
    INVENTORY_ANALYSIS_PRESET_GROUP_ID,
    INVENTORY_ANALYSIS_PRESETS,
  )

  if (activePreset?.meta?.kind === "calendar") {
    return (
      <InventoryCalendar
        presetViews={INVENTORY_ANALYSIS_PRESETS}
        presetGroupId={INVENTORY_ANALYSIS_PRESET_GROUP_ID}
      />
    )
  }

  return (
    <Inventory
      presetViews={INVENTORY_ANALYSIS_PRESETS}
      presetGroupId={INVENTORY_ANALYSIS_PRESET_GROUP_ID}
    />
  )
}
